import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { HistoricoDocumentalPage } from "@/features/historico-documental/components/HistoricoDocumentalPage";
import { filtrosHistoricoQueryOptions } from "@/features/historico-documental/hooks/use-historico";

/**
 * Filtros del Histórico Documental · viven en la URL (spec §7.1) para que la
 * consulta sea compartible y el back/forward del navegador funcione.
 */
export interface HistoricoSearch {
  desde?: string;
  hasta?: string;
  rfc?: string;
  acreedor?: string;
  organizacionId?: string;
  clasificacion?: string;
  page?: number;
}

const str = (v: unknown): string | undefined =>
  typeof v === "string" && v !== "" ? v : undefined;

/**
 * Ruta `/historico-documental` (P37) · consulta transversal del acervo
 * documental para roles internos (RN-03 · el servidor re-valida SIEMPRE).
 * Loader precarga los combos.
 */
export const Route = createFileRoute("/_authed-tw/historico-documental")({
  validateSearch: (search: Record<string, unknown>): HistoricoSearch => ({
    desde: str(search.desde),
    hasta: str(search.hasta),
    rfc: str(search.rfc),
    acreedor: str(search.acreedor),
    organizacionId: str(search.organizacionId),
    clasificacion: str(search.clasificacion),
    page:
      typeof search.page === "number" && search.page > 1 ? Math.floor(search.page) : undefined,
  }),
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(filtrosHistoricoQueryOptions()),
  component: () => (
    <PermissionGate permisos={[PERMISOS.historicoDocumentalVer]}>
      <HistoricoDocumentalPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
